import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Request methods for application related calls
 */
@Injectable({
  providedIn: 'root'
})
export class ICheckGatewayService {
  constructor(private httpClient: HttpClient) {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getTransactionDetails(request: string, apiURL: string, headers: any): Observable<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, object-shorthand
    return this.httpClient.post<any>(`${apiURL}`, request, { headers: headers });
  }
}
